import { render, staticRenderFns } from "./ReportAssignUser.vue?vue&type=template&id=18515958"
import script from "./ReportAssignUser.vue?vue&type=script&lang=js"
export * from "./ReportAssignUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports